export const FETCH_NOTIFICATIONS_REQUEST = 'FETCH_NOTIFICATIONS_REQUEST'
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS'
export const FETCH_NOTIFICATIONS_FAILURE = 'FETCH_NOTIFICATIONS_FAILURE'

export const TAG_NOTIFICATION_AS_READ_REQUEST = 'TAG_NOTIFICATION_AS_READ_REQUEST'
export const TAG_NOTIFICATION_AS_READ_SUCCESS = 'TAG_NOTIFICATION_AS_READ_SUCCESS'
export const TAG_NOTIFICATION_AS_READ_FAILURE = 'TAG_NOTIFICATION_AS_READ_FAILURE'
